import { useEffect, useState } from 'react';
import axios from 'axios';
import { rooms as fallbackRooms } from '../data/mock';

let cache = null;
let inflight = null;

// One shared fetch of /api/public/rooms for SEO consumers (schema, landing copy); falls back to mock data offline.
export const fetchRooms = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/rooms`)
      .then((res) => { cache = res.data?.length ? res.data : fallbackRooms; return cache; })
      .catch(() => fallbackRooms);
  }
  return inflight;
};

export const useRooms = () => {
  const [rooms, setRooms] = useState(cache || fallbackRooms);
  useEffect(() => {
    let alive = true;
    fetchRooms().then((r) => { if (alive) setRooms(r); });
    return () => { alive = false; };
  }, []);
  return rooms;
};
